import React, { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { ResourceList } from '@/Core/UI/CrudResource'
import { createCrudResourceContext } from '@/Core/UI/CrudResource/CrudResourceContextProvider'
import { DriverResource } from '../Resources/DriverResource'
import { InvitationDriver } from '../Components/InvitationDriver'
import { IPageConfig } from '@/Core/Contracts/UI'
import { GiSteeringWheel } from 'react-icons/gi'

const DriverPage = observer(() => {
    const listContext = useMemo(() =>
        createCrudResourceContext({
            contextType: 'list',
            registryKey: 'Transport.Driver.list',
            resource: DriverResource,
        } as any), [])

    const inviteOpen: boolean = listContext.states?.openInviteDrawer === true

    return (
        <>
            <ResourceList crudContext={listContext} />
            <InvitationDriver
                crudContext={listContext}
                title="Запросити водія"
                open={inviteOpen}
                onClose={() => listContext.setState('openInviteDrawer', false)}
            />
        </>
    )
})

export const pageConfig: IPageConfig = {
    route: '/transport/drivers',
    title: 'Водії',
    icon: <GiSteeringWheel />,
}

export default DriverPage
